import HtmlEditor, {
    Item,
    MediaResizing,
    Toolbar
} from 'devextreme-react/html-editor';
import TagBox from 'devextreme-react/tag-box';
import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import { FormGroup } from '../../../../components/form-group';
const sizeValues = ['8pt', '10pt', '12pt','13pt', '14pt', '18pt', '24pt', '36pt'];
const fontValues = ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'];
const headerValues = [false, 1, 2, 3, 4, 5];
const tabs = [
    { name: 'From This Device', value: ['file'] },
    { name: 'From the Web', value: ['url'] },
    { name: 'Both', value: ['file', 'url'] },
];
const _mentionsConfig = {
    dataSource: [
        { text: "ho_ten_hoc_sinh" },
        { text: "ngay" },
        { text: "thang" },
        { text: "nam" },
    ],
    searchExpr: 'text',
    displayExpr: 'text',
    valueExpr: 'text',
};
const NoiDungThuVNModal = ({
    value,
    onSuccess,
    onClose
}) => {
    const { dm_coso_id } = useSelector(x => x.coSo);
    const [mentionsConfig, setMentionsConfig] = useState(_mentionsConfig);
    const ref = useRef()
    const handleSubmit = async () => {
        if (ref.current) {
            const body = ref.current.instance.option('value');
            onSuccess(body);
        }
    }
    const onCustomItemCreating = (args) => {
        const newValue = args.text;
        debugger
        const isItemInDataSource = mentionsConfig.dataSource.find((item) => item.text === newValue);
        if (!isItemInDataSource) {
            setMentionsConfig({
                ...mentionsConfig,
                dataSource: [
                    ...mentionsConfig.dataSource,
                    {
                        text: newValue
                    }
                ]

            })
        }
    }

    return (
        <div>
            <Modal
                open={true}
                size="large"
                dimmer={'blurring'}
                onClose={() => {
                    // setisShowEditModal(false)
                }}
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header>
                    Cập nhật nội dung thư chia sẻ
                </Modal.Header>
                <Modal.Content>
                    <form className="ui">
                        <div className="row">
                            <div className="col-md-12">
                                <FormGroup label={"Data source item"}>
                                    <TagBox items={mentionsConfig.dataSource.map(x => x.text)}
                                        value={mentionsConfig.dataSource.map(x => x.text)}
                                        stylingMode='outlined'
                                        acceptCustomValue={true}
                                        onCustomItemCreating={onCustomItemCreating} />
                                    <p style={{ marginTop: 5 }}>
                                        Để thêm 1 field mới, anh/chị điền tên field rồi nhấn Enter. Sau đó anh/chị có thể add trường đó vào body thư chia sẻ bằng phím @ rồi chọn tới field cần đưa vào.
                                    </p>
                                </FormGroup>
                            </div>
                            <div className="col-md-12">
                                <FormGroup label={"Nội dung thư chia sẻ"}>
                                    <HtmlEditor
                                        height={window.innerHeight - 300}
                                        defaultValue={value}
                                        mentions={[mentionsConfig]}
                                        ref={ref}
                                    >
                                        <MediaResizing enabled={true} />
                                        {/* <ImageUpload tabs={['file', 'url']} fileUploadMode="base64" /> */}
                                        <Toolbar multiline={true}>
                                            <Item name="undo" />
                                            <Item name="redo" />
                                            <Item name="separator" />
                                            <Item
                                                name="size"
                                                acceptedValues={sizeValues}
                                            />
                                            <Item
                                                name="font"
                                                acceptedValues={fontValues}
                                            />
                                            <Item name="separator" />
                                            <Item name="bold" />
                                            <Item name="italic" />
                                            <Item name="strike" />
                                            <Item name="underline" />
                                            <Item name="separator" />
                                            <Item name="alignLeft" />
                                            <Item name="alignCenter" />
                                            <Item name="alignRight" />
                                            <Item name="alignJustify" />
                                            <Item name="separator" />
                                            <Item name="orderedList" />
                                            <Item name="bulletList" />
                                            <Item name="separator" />
                                            <Item
                                                name="header"
                                                acceptedValues={headerValues}
                                            />
                                           <Item name="separator" />
                                            <Item name="color" />
                                            <Item name="background" />
                                            <Item name="separator" />
                                            <Item name="link" />
                                            <Item name="image" />
                                            <Item name="separator" />
                                            <Item name="clear" />
                                            <Item name="codeBlock" />
                                            <Item name="blockquote" />
                                            <Item name="separator" />
                                            <Item name="insertTable" />
                                            <Item name="deleteTable" />
                                            <Item name="insertRowAbove" />
                                            <Item name="insertRowBelow" />
                                            <Item name="deleteRow" />
                                            <Item name="insertColumnLeft" />
                                            <Item name="insertColumnRight" />
                                            <Item name="deleteColumn" />
                                        </Toolbar>
                                    </HtmlEditor>
                                </FormGroup>
                            </div>

                        </div>
                    </form>
                </Modal.Content>
                <Modal.Actions>

                    <div>
                        <button onClick={() => {
                            onClose()
                        }} className="p-btn p-btn-sm">
                            Đóng
                        </button>
                        <button
                            // disabled={isSaving}
                            onClick={() => {
                                handleSubmit()
                            }}
                            className="p-btn p-prim-col p-btn-sm margin-left-10"
                        >
                            Cập nhật
                        </button>
                    </div>
                </Modal.Actions>
            </Modal>
        </div>
    );
};

export default NoiDungThuVNModal;